export enum FanTokenOfferingsPage {
	Home = 'home',
	Partner = 'partner'
}
